import { atom } from 'recoil';

export const globalAddressBene = atom({
  key: 'globalAddressBene',
  default: undefined,
});
